import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SendIcon, CheckCircle2, MailIcon, MapPinIcon } from 'lucide-react';
const reasons = ['General enquiry', 'Business partnership', 'Press & media', 'Bug report', 'Feature request', 'Other'];
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    reason: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-339" data-mp="15g8dv6gsxet0">
      <SEO title="Contact | KittyPot" description="Get in touch with the KittyPot team. KittyPot helps groups track shared expenses, split costs fairly, and see the simplest way to settle up." ogTitle="Contact KittyPot" ogDescription="Track shared expenses, split costs fairly, and see the simplest way to settle up." path="/contact" data-id="element-340" data-mp="19fz1x2ey1gtu" />
      <Navbar data-id="element-341" data-mp="minps1lv2k9g" />
      <main className="pt-36 pb-24" data-id="element-342" data-mp="qi68cqq7mj94">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-343" data-mp="qj7kkyiypbsf">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="text-center mb-14" data-id="element-344" data-mp="vh941kkavd4f">
            <h1 className="text-4xl md:text-5xl font-black text-kitty-dark mb-4 tracking-tight" data-id="element-345" data-mp="26x7hs1qfanbz">
              Contact KittyPot
            </h1>
            <p className="text-lg text-gray-500 max-w-md mx-auto" data-id="element-346" data-mp="2bto7h0d9t9r6">
              Have a question about KittyPot or early access? Get in touch.
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-5 gap-10 items-start" data-id="element-347" data-mp="1h7ha1l9g003i">
            {/* Contact Form */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="lg:col-span-3" data-id="element-348" data-mp="1w5178603kqz4">
              {submitted ? <div className="bg-white rounded-2xl p-10 md:p-14 shadow-card border border-gray-100 text-center" data-id="element-349" data-mp="yikdfaqkovi4">
                  <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6" data-id="element-350" data-mp="1d7gutyeirkve">
                    <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-351" data-mp="18enoj63ek4h7" />
                  </div>
                  <h2 className="text-2xl font-bold text-kitty-dark mb-3" data-id="element-352" data-mp="kote0v6k2s04">
                    Message sent!
                  </h2>
                  <p className="text-gray-500 max-w-sm mx-auto" data-id="element-353" data-mp="2remya1tni0ry">
                    Thanks for reaching out. The KittyPot team will get back to
                    you as soon as possible.
                  </p>
                </div> : <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-8 md:p-10 shadow-card border border-gray-100 relative overflow-hidden" data-id="element-354" data-mp="2hgz2r9o80p8q">
                  <div className="absolute top-0 left-0 right-0 h-1.5 bg-kitty-yellow" data-id="element-355" data-mp="2mftho0j2htnk" />

                  <div className="space-y-6 mt-2" data-id="element-356" data-mp="3a5ntqfvkbe6r">
                    <div data-id="element-357" data-mp="3f3z7v2sw4aus">
                      <label htmlFor="name" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-358" data-mp="3f367cjkiyhl3">
                        Full Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow" data-id="element-359" data-mp="355rral2ijutb" />
                    </div>

                    <div data-id="element-360" data-mp="257arevhvtew1">
                      <label htmlFor="email" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-361" data-mp="256spbi8jg6g7">
                        Email
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow" data-id="element-362" data-mp="205v38ukeqs9f" />
                    </div>

                    <div data-id="element-363" data-mp="2j0s9scyu0lkh">
                      <label htmlFor="reason" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-364" data-mp="2exds7hv8vx4x">
                        Reason for contacting us
                      </label>
                      <select id="reason" name="reason" value={formData.reason} onChange={handleChange} required className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 text-base transition-shadow appearance-none bg-white bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%239ca3af%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')] bg-[length:20px] bg-[right_12px_center] bg-no-repeat pr-10" data-id="element-365" data-mp="13hykpk5etmvk">
                        <option value="" disabled data-id="element-366" data-mp="aozoxgyip8q5">
                          Select a reason
                        </option>
                        {reasons.map(reason => <option key={reason} value={reason} data-id="element-367" data-mp="2cj8jl726iyzk">
                            {reason}
                          </option>)}
                      </select>
                    </div>

                    <div data-id="element-368" data-mp="3krnz4jb2erwz">
                      <label htmlFor="message" className="block text-sm font-semibold text-kitty-dark mb-2" data-id="element-369" data-mp="3kt8x6iwl8szl">
                        Message
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder="Enter your message" required rows={5} className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-kitty-yellow focus:border-transparent text-gray-900 placeholder-gray-400 text-base transition-shadow resize-vertical" data-id="element-370" data-mp="3tte28meb7fal" />
                    </div>

                    <button type="submit" className="w-full bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark py-4 rounded-full font-bold text-lg transition-all active:scale-[0.98] shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-371" data-mp="gd69sef9a9q8">
                      Send Message
                      <SendIcon className="w-5 h-5" data-id="element-372" data-mp="le3twwjttdud" />
                    </button>
                  </div>
                </form>}
            </motion.div>

            {/* Contact Info Sidebar */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="lg:col-span-2 space-y-6" data-id="element-373" data-mp="19yql5vv5c5y4">
              <div className="bg-white rounded-2xl p-7 shadow-card border border-gray-100" data-id="element-374" data-mp="m8mlfzl2wqce">
                <div className="w-10 h-10 rounded-xl bg-kitty-yellow/20 flex items-center justify-center mb-4" data-id="element-375" data-mp="m6rxeceigi43">
                  <MailIcon className="w-5 h-5 text-kitty-yellow-700" data-id="element-376" data-mp="caghlcfppa4w" />
                </div>
                <h3 className="font-bold text-kitty-dark mb-1" data-id="element-377" data-mp="h9jfmcx9yg3d">Email us</h3>
                <a href="mailto:support@kittypot.com" className="text-gray-500 hover:text-kitty-dark transition-colors text-sm" data-id="element-378" data-mp="h9t9wcpcr9ev">
                  support@kittypot.com
                </a>
              </div>

              <div className="bg-white rounded-2xl p-7 shadow-card border border-gray-100" data-id="element-379" data-mp="7dghdi5jn1lp">
                <div className="w-10 h-10 rounded-xl bg-kitty-yellow/20 flex items-center justify-center mb-4" data-id="element-380" data-mp="nos9uyrs9ko7">
                  <MapPinIcon className="w-5 h-5 text-kitty-yellow-700" data-id="element-381" data-mp="ipxk1cveevul" />
                </div>
                <h3 className="font-bold text-kitty-dark mb-1" data-id="element-382" data-mp="dui5eipkgvx4">Our address</h3>
                <address className="not-italic text-gray-500 text-sm leading-relaxed" data-id="element-383" data-mp="8tccokvwp8nl">
                  KittyPot Ltd
                  <br data-id="element-384" data-mp="4tts5q7zyzla" />
                  Flat 2 Minavon
                  <br data-id="element-385" data-mp="ihfe02dyo3" />
                  Cardiff, CF14 6BE
                  <br data-id="element-386" data-mp="3r7btxe0b5k7x" />
                  United Kingdom
                </address>
              </div>

              <div className="bg-gray-950 rounded-2xl p-7 text-white" data-id="element-387" data-mp="3m8qtpel230jh">
                <p className="text-sm font-medium mb-1" data-id="element-388" data-mp="3m6e36d18fhut">Response time</p>
                <p className="text-gray-400 text-sm" data-id="element-389" data-mp="3h8w0v5hq00vs">
                  We typically reply within 24 hours on business days.
                </p>
              </div>

              <p className="text-sm text-gray-500" data-id="element-390" data-mp="1sqb2raqgga33">
                <Link to="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 transition-colors hover:text-kitty-yellow-700" data-id="element-391" data-mp="1sruj11c42l4v">
                  Privacy Policy
                </Link>
                <span className="mx-2 text-gray-300" data-id="element-392" data-mp="21omxnoyctu1c">·</span>
                <Link to="/delete-account" className="font-semibold text-kitty-dark underline underline-offset-2 transition-colors hover:text-kitty-yellow-700" data-id="element-393" data-mp="26p0yalxmm1pc">
                  Delete account
                </Link>
              </p>
            </motion.div>
          </div>
        </div>
      </main>
      <Footer data-id="element-394" data-mp="1iydotw82b40o" />
    </div>;
}